module.exports = __webpack_public_path__ + "img/disanfangceshi.d5286a87.png";